import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { mktApi, errMsg } from './marketingApi';
import { todayJst } from '@/utils/jstDate';

export default function KanseiDialog({ open, onOpenChange, order, onSaved }) {
  const [completedAt, setCompletedAt] = useState('');
  const [finalAmount, setFinalAmount] = useState('');
  const [technoaNo, setTechnoaNo] = useState('');
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setCompletedAt(todayJst());
    setFinalAmount(order?.total != null ? String(order.total) : '');
    setTechnoaNo('');
    setNote('');
  }, [open, order]);

  const save = async () => {
    setSaving(true);
    try {
      const updated = await mktApi.kansei(order.id, {
        completed_at: completedAt || null,
        final_amount: finalAmount === '' ? null : Number(finalAmount),
        technoa_no: technoaNo || null,
        note: note || null,
      });
      toast.success('売上確定を記録し、受注を完了しました');
      onSaved?.(updated);
      onOpenChange(false);
    } catch (e) { toast.error(errMsg(e)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="mkt-kansei-dialog">
        <DialogHeader><DialogTitle>売上確定 — {order?.order_no}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <p className="rounded-lg bg-fuchsia-50 border border-fuchsia-100 px-3 py-2 text-[11px] text-fuchsia-700">
            Technoa側で完成入力（売上計上）した内容をここに記録すると、この受注は「完了」になります。
          </p>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs font-medium text-zinc-600">売上確定日 <span className="text-red-500">*</span></label>
              <Input type="date" value={completedAt} onChange={(e) => setCompletedAt(e.target.value)} className="mt-1" data-testid="mkt-kansei-date" />
            </div>
            <div>
              <label className="text-xs font-medium text-zinc-600">確定売上金額（税込）</label>
              <Input type="number" step="any" value={finalAmount} onChange={(e) => setFinalAmount(e.target.value)} className="mt-1 text-right" data-testid="mkt-kansei-amount" />
            </div>
          </div>
          <div>
            <label className="text-xs font-medium text-zinc-600">Technoa伝票・受注番号</label>
            <Input value={technoaNo} onChange={(e) => setTechnoaNo(e.target.value)} placeholder="例）T-12345" className="mt-1" data-testid="mkt-kansei-technoa" />
          </div>
          <div>
            <label className="text-xs font-medium text-zinc-600">備考（数量差異など）</label>
            <Textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2} className="mt-1" data-testid="mkt-kansei-note" />
          </div>
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="mkt-kansei-cancel-btn">キャンセル</Button>
            <Button onClick={save} disabled={saving} className="bg-teal-700 hover:bg-teal-800" data-testid="mkt-kansei-submit-btn">
              {saving ? '保存中…' : '売上確定して完了'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
